import { toStoryModePath } from "../storyCanvas/drillThroughMappers";

/**
 * The URL the Share dialog's Link tab copies: the public `/s/<slug>` link when there is one,
 * else the caller's own link, else the story's page (members sign in to open it).
 * Without the story's workspace it can only point at the page the user is on, when that is this story.
 */
export const shareLinkUrl = (
  origin: string,
  { slug, linkUrl, workspaceId, storyId, currentHref }: {
    slug?: string | null;
    linkUrl?: string;
    workspaceId?: string;
    storyId: string;
    currentHref: string;
  },
): string | null => {
  if (slug) return `${origin}/s/${slug}`;
  if (linkUrl) return linkUrl;
  if (workspaceId && storyId) return `${origin}${toStoryModePath(workspaceId, storyId, "build")}`;
  return storyId && currentHref.includes(`/story/${storyId}/`) ? currentHref : null;
};
